export interface UITriggeredOption {
  type: string,
  payload?: {},
  onlyOnce?: boolean,
}

const uiTriggered = (action: UITriggeredOption) => action

export default uiTriggered;
